module.exports = "#app-top-menu{background-color:#064180;padding:0rem 4rem}#app-top-menu .menu{background-color:#064180}#app-top-menu .menu>li>a{padding:0.5rem;color:#fff}#app-top-menu .menu>li>a:hover{color:#faa635}#app-top-menu .top-bar-left .menu>li>a{padding:0.6rem 0.3rem;font-size:0.8rem}#app-top-menu .top-bar-right{flex:0 0 0px !important}@media only screen and (max-width: 40em){#app-top-menu{padding:0;overflow-x:hidden}#app-top-menu .menu{height:0}}\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/modules/core/components/top-menu/TopMenuComponent.sass
// module id = 93
// module chunks = 0